// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'monitor-lock';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m6.188 15.188.562-3.376M4.5 15.188h3.938M.563 8.813h9m-1.125 3H2.811a2.25 2.25 0 0 1-2.25-2.25v-6.75a2.25 2.25 0 0 1 2.25-2.25h12.376a2.25 2.25 0 0 1 2.25 2.25v4.5m-1.124 4.5h-4.5c-.622 0-1.126.503-1.126 1.124v3.376c0 .62.504 1.125 1.126 1.125h4.5c.62 0 1.125-.504 1.125-1.125v-3.375c0-.622-.504-1.126-1.125-1.126z' />
    <path d='M14.063 8.438a2.25 2.25 0 0 0-2.25 2.25v1.124h4.5v-1.124a2.25 2.25 0 0 0-2.25-2.25zm.003 6.487a.281.281 0 1 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
